import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getShumaProperties = ({shumaId}) => dispatch => {
  dispatch({
    type: A.GET_SHUMA_PROPERTIES,
  });

  const data = {shumaID: parseInt(shumaId, 10)};

  return axios.post(api.GET_SHUMA_PROPERTIES, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_SHUMA_PROPERTIES_SUCCESS,
        payload: {
          shumaTypeID: body.shumaTypeID,
          propertyTypeID: body.propertyTypeID,
          firmShumaID: body.firmShumaID,
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_SHUMA_PROPERTIES_FAILURE,
        payload: err.message
      })
    });
};
